/*---------------------------------------------------------------------------------------------
* Copyright (c) Bentley Systems, Incorporated. All rights reserved.
* See LICENSE.md in the project root for license terms and full copyright notice.
*--------------------------------------------------------------------------------------------*/
/** @packageDocumentation
 * @module PropertyEditors
 */

// cspell:ignore buttongroup

/**
 * Standard Editor Names for property editors.
 * @deprecated Use [[StandardEditorNames]] in ui-abstract instead
 * @beta
 */
export enum StandardEditorNames {
  ColorPicker = "color-picker",
  EnumButtonGroup = "enum-buttongroup",
  IconPicker = "icon-picker",
  MultiLine = "multi-line",
  NumberCustom = "number-custom",
  NumericInput = "numeric-input",
  Slider = "slider",
  Toggle = "toggle",
  WeightPicker = "weight-picker",
}
